import {getFetchNonce} from '@github-ui/fetch-nonce'
import type {JSX} from 'react'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'

export type IncludeFragmentProps = JSX.IntrinsicElements['include-fragment'] & {
  ref?: React.Ref<HTMLElement>
}

export function IncludeFragment({ref, children, src, ...props}: IncludeFragmentProps) {
  const {isServer: isSSR} = useRuntimeEnvironment()

  return (
    // eslint-disable-next-line react/forbid-elements
    <include-fragment {...props} ref={ref} {...(isSSR ? {} : {src, 'data-nonce': getFetchNonce()})}>
      {children}
    </include-fragment>
  )
}
